import React from 'react';
import ReactDOM from 'react-dom';

import LayoutProto from './layout-proto';

import NavigationPanel from '../navigation/navigation-panel';
import PresenceConnectivity from '../components/connectivity/connectivity';
import TaskTray from '../components/task-tray/task-tray';
import LayoutLoading from "../components/loading/loading";
import LayoutViewLoading from "../components/view-loading/loading";
import UIRightPanel from "../right-panel/right-panel";
import UIRightPanelMain from "../right-panel-main/right-panel-main";
import UICenter from "../center/center";
import LayoutItemView from "../item-view/layout-item-view";
import {UIType} from "../ui/@const";

// const debug = '{UI_Layout}'
const debug = false

export default class UI_Layout extends LayoutProto {

    constructor(type: UIType) {
        super();

        this.type = type
    }

    render(options={}) {

        debug && console.count(debug + "render()")

        const navType = gd.ui.type === UIType.TOP ? "top" : "left"

        ReactDOM.render(
            <div id="ui-div-zero" className={gd.ui.layoutCSSClass}>

                {/* Main navigaiton panel */}
                <NavigationPanel />

                {/* Additional top panel*/}
                {!!gd.ui.TopPanel &&
                    <gd.ui.TopPanel />
                }

                <UICenter navType={navType}>
                    <div id="ui-top-panel"/>
                    <div id="ui-content-center" className="ui-main">
                        <div id="ui-page" className=""/>
                        <UIRightPanel />
                    </div>

                    <UIRightPanelMain />
                    <LayoutLoading />
                </UICenter>

                <gd.ui.UILeftClass />

                <div id="ui-analytics"/>

                <LayoutItemView />

                <div id="ui-new-task" className="hidden"/>

                <div id="ui-modal"/>

                <LayoutViewLoading />

                <PresenceConnectivity />

                <TaskTray />
            </div>,
            document.getElementById("ui-layout-container")
        );

        this.domZero = document.getElementById("ui-div-zero");

        //Init main area size
        this.calculateWidth();
    }
}
